import script from "./cau-hinh-chung.vue?vue&type=script&setup=true&lang=js"
export * from "./cau-hinh-chung.vue?vue&type=script&setup=true&lang=js"

import "./cau-hinh-chung.scss?vue&type=style&index=0&id=e57f12b2&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e57f12b2"]])

export default __exports__